"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var measurements_1 = require("../../admin/state/measurements");
var measurement_unit_1 = require("./measurement_unit");
var util_1 = require("util");
var locale2_1 = __importDefault(require("locale2"));
exports.EmptySizeChart = {
    unit: measurement_unit_1.metric,
    measurements: [],
    topLevelOptionLabel: undefined,
    availableOptionLabels: [],
};
exports.measurementsToMap = function (measurements) {
    var map = {};
    measurements.forEach(function (measurement) {
        if (measurement.variantId) {
            if (!map[measurement.variantId]) {
                map[measurement.variantId] = {};
            }
            map[measurement.variantId][measurement.dimensionKey] = measurement;
        }
    });
    return map;
};
exports.measurementAnnotationsToMap = function (measurements) {
    var annotationsOnly = {};
    measurements.forEach(function (measurement) {
        annotationsOnly[measurement.dimensionKey] = measurement;
    });
    return annotationsOnly;
};
exports.localizedNumber = function (value) {
    return value.toLocaleString(locale2_1.default);
};
exports.twoDecimalPlaces = function (value) {
    return Math.round(value * 100) / 100;
};
exports.convertCmToMm = function (value) {
    return value * 10;
};
var displayMetric = function (measurement, measurementUnit, hasLargeMeasurement) {
    var startCM = measurementUnit === measurement_unit_1.imperial ?
        measurement.startLength * 2.54
        : measurement.startLength;
    var endCM = measurement.endLength && measurementUnit === measurement_unit_1.imperial ?
        measurement.endLength * 2.54
        : measurement.endLength;
    if (endCM && endCM !== startCM) {
        if (hasLargeMeasurement) {
            return exports.localizedNumber(exports.twoDecimalPlaces(startCM)) + " - " + exports.localizedNumber(exports.twoDecimalPlaces(endCM)) + " cm";
        }
        return exports.localizedNumber(exports.convertCmToMm(exports.twoDecimalPlaces(startCM))) + " - " + exports.localizedNumber(exports.convertCmToMm(exports.twoDecimalPlaces(endCM))) + " mm";
    }
    if (hasLargeMeasurement) {
        return exports.localizedNumber(exports.twoDecimalPlaces(startCM)) + " cm";
    }
    return exports.localizedNumber(exports.convertCmToMm(exports.twoDecimalPlaces(startCM))) + " mm";
};
var displayImperial = function (measurement, measurementUnit) {
    var startInches = measurementUnit === measurement_unit_1.metric ?
        measurement.startLength / 2.54
        : measurement.startLength;
    var endInches = measurement.endLength && measurementUnit === measurement_unit_1.metric ?
        measurement.endLength / 2.54
        : measurement.endLength;
    if (endInches && startInches !== endInches) {
        return exports.localizedNumber(exports.twoDecimalPlaces(startInches)) + "\" - " + exports.localizedNumber(exports.twoDecimalPlaces(endInches)) + "\"";
    }
    return exports.localizedNumber(exports.twoDecimalPlaces(startInches)) + "\"";
};
exports.displayMeasurement = function (measurement, measurementUnit, displayUnit, showMM) {
    switch (displayUnit) {
        case measurement_unit_1.imperial:
            return displayImperial(measurement, measurementUnit);
        case measurement_unit_1.metric:
        default:
            return displayMetric(measurement, measurementUnit, showMM);
    }
};
/* Size chart operations */
exports.sizeChartHasLabel = function (sizeChart, option) {
    return sizeChart.availableOptionLabels.indexOf(option) >= 0;
};
exports.cmToInches = function (cm) { return cm / 2.54; };
exports.inchesToCm = function (inches) { return inches * 2.54; };
exports.updateSizeChartUnit = function (sizeChart, unit) {
    // cm to inches
    if (sizeChart.unit === measurement_unit_1.metric && unit === measurement_unit_1.imperial) {
        var measurements = sizeChart.measurements.map(function (m) {
            return __assign({}, m, { startLength: exports.cmToInches(m.startLength), startLengthDisplay: undefined, endLength: m.endLength ? exports.cmToInches(m.endLength) : undefined, endLengthDisplay: undefined });
        });
        return __assign({}, sizeChart, { unit: unit, measurements: measurements });
    }
    // inches to cm
    if (sizeChart.unit === measurement_unit_1.imperial && unit === measurement_unit_1.metric) {
        var measurements = sizeChart.measurements.map(function (m) {
            return __assign({}, m, { startLength: exports.inchesToCm(m.startLength), startLengthDisplay: undefined, endLength: m.endLength ? exports.inchesToCm(m.endLength) : undefined, endLengthDisplay: undefined });
        });
        return __assign({}, sizeChart, { unit: unit, measurements: measurements });
    }
    return sizeChart;
};
exports.updateSizeChartTopLevel = function (sizeChart, topLevel) {
    if (exports.sizeChartHasLabel(sizeChart, topLevel)) {
        return __assign({}, sizeChart, { topLevelOptionLabel: topLevel });
    }
    return sizeChart;
};
exports.updateSelectedOption = function (sizeChart, option, set) {
    if (set && !exports.sizeChartHasLabel(sizeChart, option)) {
        var newOptions = sizeChart.availableOptionLabels.concat([
            option,
        ]);
        // update top-level option
        var onlyOneOption = newOptions.length === 1;
        var topLevelOptionLabel = onlyOneOption ? option : sizeChart.topLevelOptionLabel;
        return __assign({}, sizeChart, { availableOptionLabels: newOptions, topLevelOptionLabel: topLevelOptionLabel });
    }
    else if (!set) {
        var newOptions = sizeChart.availableOptionLabels.filter(function (oldOption) { return option !== oldOption; });
        // update top-level option
        var topLevelRemoved = option === sizeChart.topLevelOptionLabel;
        var topLevelOptionLabel = topLevelRemoved ? newOptions[0] : sizeChart.topLevelOptionLabel;
        return __assign({}, sizeChart, { availableOptionLabels: newOptions, topLevelOptionLabel: topLevelOptionLabel });
    }
    return sizeChart;
};
var VALID_NUMBER_REGEX = /^[0-9]+(\.?[0-9]*)?$/;
exports.upsertMeasurements = function (sizeChart, affectedVariants, dimensionKey, newLength, update) {
    var affectedVariantIds = affectedVariants.map(function (pv) { return pv.id; });
    var oldAffectedMeasurements = {};
    var unaffectedMeasurements = sizeChart.measurements.filter(function (m) {
        var variantIdIsAffected = m.variantId && affectedVariantIds.indexOf(m.variantId) > -1;
        var dimensionKeyIsAffected = m.dimensionKey === dimensionKey;
        var isUnaffected = !(variantIdIsAffected && dimensionKeyIsAffected);
        // side-effect: update oldAffectedMeasurements
        if (m.variantId && !isUnaffected) {
            oldAffectedMeasurements[m.variantId] = m;
        }
        // return unaffected measurements
        return isUnaffected;
    });
    // delete measurements if "" is passed in the start position
    if (newLength.trim() === "" && update === measurements_1.MeasurementUpdate.START) {
        return __assign({}, sizeChart, { measurements: unaffectedMeasurements });
    }
    // clear end measurements if "" is passed in the end position
    if (newLength.trim() === "" && update === measurements_1.MeasurementUpdate.END) {
        var oldMeasurements_1 = [];
        Object.keys(oldAffectedMeasurements).forEach(function (variantId) {
            var updateOldMeasurement = __assign({}, oldAffectedMeasurements[variantId]);
            // unset
            updateOldMeasurement.endLength = undefined;
            updateOldMeasurement.endLengthDisplay = undefined;
            oldMeasurements_1.push(updateOldMeasurement);
        });
        return __assign({}, sizeChart, { measurements: unaffectedMeasurements.concat(oldMeasurements_1) });
    }
    // if it's not a number, don't do anything
    var newLengthNumber = parseFloat(newLength);
    var validNumberPattern = VALID_NUMBER_REGEX.test(newLength);
    if (!util_1.isNumber(newLengthNumber) || !validNumberPattern) {
        return sizeChart;
    }
    // alter measurements if number is valid
    var affectedMeasurements = affectedVariants.map(function (pv) {
        var oldMeasurement = oldAffectedMeasurements[pv.id];
        var updateStart = update === measurements_1.MeasurementUpdate.START;
        var updateEnd = update === measurements_1.MeasurementUpdate.END;
        var startLength = 0;
        var endLength;
        var startLengthDisplay;
        var endLengthDisplay;
        if (oldMeasurement) {
            startLength = updateStart ? newLengthNumber : oldMeasurement.startLength;
            startLengthDisplay = updateStart ? newLength : oldMeasurement.startLengthDisplay;
            endLength = updateEnd ? newLengthNumber : oldMeasurement.endLength;
            endLengthDisplay = updateEnd ? newLength : oldMeasurement.endLengthDisplay;
        }
        else {
            if (updateStart) {
                startLength = newLengthNumber;
                startLengthDisplay = newLength;
            }
            if (updateEnd) {
                endLength = newLengthNumber;
                endLengthDisplay = newLength;
            }
        }
        return {
            variantId: pv.id,
            dimensionKey: dimensionKey,
            startLength: startLength,
            endLength: endLength,
            startLengthDisplay: startLengthDisplay,
            endLengthDisplay: endLengthDisplay,
        };
    });
    var newMeasurements = unaffectedMeasurements.concat(affectedMeasurements);
    return __assign({}, sizeChart, { measurements: newMeasurements });
};
exports.updateGlobalMeasurement = function (globalMeasurements, dimensionKey, newMeasurement, update) {
    var updateStart = update === measurements_1.MeasurementUpdate.START;
    var updateEnd = update === measurements_1.MeasurementUpdate.END;
    // clear global measurements if start value is cleared
    if (newMeasurement.trim() === "" && updateStart) {
        var newMeasurements = __assign({}, globalMeasurements.measurements);
        delete newMeasurements[dimensionKey];
        return __assign({}, globalMeasurements, { measurements: newMeasurements });
    }
    if (newMeasurement.trim() === "" && updateEnd) {
        var newMeasurements = __assign({}, globalMeasurements.measurements);
        // delete end and update
        var newGlobalMeasurement = __assign({}, newMeasurements[dimensionKey]);
        newGlobalMeasurement.end = undefined;
        newMeasurements[dimensionKey] = newGlobalMeasurement;
        return __assign({}, globalMeasurements, { measurements: newMeasurements });
    }
    var newMeasurementNumber = parseFloat(newMeasurement);
    var validNumberPattern = VALID_NUMBER_REGEX.test(newMeasurement);
    if (util_1.isNumber(newMeasurementNumber) && validNumberPattern) {
        var newMeasurements = __assign({}, globalMeasurements);
        var globalMeasurement = newMeasurements.measurements[dimensionKey];
        var startLength = 0;
        var startLengthDisplay = void 0;
        var newEnd = void 0;
        if (updateStart) {
            startLength = newMeasurementNumber;
            startLengthDisplay = newMeasurement;
            if (globalMeasurement) {
                newEnd = globalMeasurement.end;
            }
        }
        if (updateEnd) {
            newEnd = {
                value: newMeasurementNumber,
                display: newMeasurement,
            };
            if (globalMeasurement) {
                startLength = globalMeasurement.start.value;
                startLengthDisplay = globalMeasurement.start.display;
            }
        }
        // update
        var newGlobalMeasurement = {
            start: { value: startLength, display: startLengthDisplay },
            end: newEnd,
        };
        newMeasurements.measurements[dimensionKey] = newGlobalMeasurement;
        return newMeasurements;
    }
    return globalMeasurements;
};
exports.updateGlobalMeasurementUnit = function (globalMeasurements, unit) {
    if (globalMeasurements.unit === measurement_unit_1.imperial && unit === measurement_unit_1.metric) {
        var dimensionKeys = Object.keys(globalMeasurements.measurements);
        var newMeasurements_1 = __assign({}, globalMeasurements.measurements);
        dimensionKeys.forEach(function (dimensionKey) {
            var start = {
                value: exports.inchesToCm(newMeasurements_1[dimensionKey].start.value),
                display: undefined,
            };
            var endMeasurement = newMeasurements_1[dimensionKey];
            var end = endMeasurement.end && {
                value: exports.inchesToCm(endMeasurement.end.value),
                display: undefined,
            };
            newMeasurements_1[dimensionKey] = { start: start, end: end };
        });
        return { unit: unit, measurements: newMeasurements_1 };
    }
    if (globalMeasurements.unit === measurement_unit_1.metric && unit === measurement_unit_1.imperial) {
        var dimensionKeys = Object.keys(globalMeasurements.measurements);
        var newMeasurements_2 = __assign({}, globalMeasurements.measurements);
        dimensionKeys.forEach(function (dimensionKey) {
            var newMeasurement = newMeasurements_2[dimensionKey];
            if (newMeasurement) {
                var start = {
                    value: exports.cmToInches(newMeasurement.start.value),
                    display: undefined,
                };
                var endMeasurement = newMeasurement.end;
                var end = endMeasurement && {
                    value: exports.cmToInches(endMeasurement.value),
                    display: undefined,
                };
                newMeasurements_2[dimensionKey] = {
                    start: start,
                    end: end,
                };
            }
        });
        return { unit: unit, measurements: newMeasurements_2 };
    }
    return globalMeasurements;
};
